/**
 * @generated SignedSource<<50bb87c90ff420b73227feb72e4a00b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CaseLinkItem_link$data = {
  readonly description: string | null;
  readonly display: boolean;
  readonly id: string;
  readonly title: string | null;
  readonly url: string;
  readonly " $fragmentType": "CaseLinkItem_link";
};
export type CaseLinkItem_link$key = {
  readonly " $data"?: CaseLinkItem_link$data;
  readonly " $fragmentSpreads": FragmentRefs<"CaseLinkItem_link">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CaseLinkItem_link",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "display",
      "storageKey": null
    }
  ],
  "type": "CaseLink",
  "abstractKey": null
};

(node as any).hash = "d974410657646224a828368f6487d116";

export default node;
